import React, { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import { HomeIcon } from '@heroicons/react/20/solid'

export interface HudsonPathPart {
  name: string
  href: string
}

interface NavBarProps {
  path: HudsonPathPart[]
}
export const BreadcrumbBar: FunctionComponent<React.PropsWithChildren<NavBarProps>> = ({
  path
}) => {
  return (
    <nav className='flex' aria-label='Breadcrumb'>
      <ol role='list' className='flex items-center space-x-4'>
        <li>
          <div>
            <Link to='/' className='text-gray-400 hover:text-gray-500'>
              <HomeIcon className='h-5 w-5 flex-shrink-0' aria-hidden='true' />
              <span className='sr-only'>Home</span>
            </Link>
          </div>
        </li>
        {path.map((page, index) => (
          <li key={page.name}>
            <div className='flex items-center'>
              <svg
                className='h-5 w-5 flex-shrink-0 text-gray-300'
                xmlns='http://www.w3.org/2000/svg'
                fill='currentColor'
                viewBox='0 0 20 20'
                aria-hidden='true'
              >
                <path d='M5.555 17.776l8-16 .894.448-8 16-.894-.448z' />
              </svg>
              <Link
                to={page.href}
                className='ml-4 text-sm font-medium text-gray-500 hover:text-gray-700'
                aria-current={index === path.length - 1 ? 'page' : undefined}
              >
                {page.name}
              </Link>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  )
}
